import { Duration } from 'luxon'

type TimeOption = {
  label: string
  value: number
}

function createTimeOptions(stepMinutes: number = 30) {
  const result: TimeOption[] = []
  const duration = Duration.fromObject({ minutes: 0 })

  for (let minute = 0; minute < 24 * 60; minute += stepMinutes) {
    result.push({
      value: minute,
      label: duration.plus({ minutes: minute }).toFormat('hh:mm'),
    })
  }

  return result
}

export type { TimeOption }
export { createTimeOptions }
